(() => {
  const setFlagEmoji = (el) => {
    const iso = (el.getAttribute('data-country-iso') || 'US').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(iso)) return;

    el.textContent = Array.from(iso, (c) => String.fromCodePoint(127397 + c.charCodeAt(0))).join('');
  };

  const init = () => {
    document.querySelectorAll('.bape-footer__phone-flag[data-country-iso]').forEach(setFlagEmoji);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

